import SignalController from './index';

const replaceProtocol = (location.protocol.startsWith('http') ? location.protocol : 'http:') + '//';

export default class GbsSignalController extends SignalController {
  /**
   * Copy from jswebrtc.js
   * @see https://github.com/kernelj/jswebrtc/blob/master/src/jswebrtc.js#L49
   * @param {string} streamUrl
   */
  private parseUrl(streamUrl: string) {
    const url = new URL(streamUrl.replace('rtmp://', replaceProtocol).replace('webrtc://', replaceProtocol).replace('rtc://', replaceProtocol));

    let vhost = url.hostname;
    let app = url.pathname.substr(1, url.pathname.lastIndexOf('/') - 1);
    const stream = url.pathname.substr(url.pathname.lastIndexOf('/') + 1);

    // parse the vhost in the params of app, that srs supports.
    app = app.replace('...vhost...', '?vhost=');
    if (app.indexOf('?') >= 0) {
      const params = app.substr(app.indexOf('?'));
      app = app.substr(0, app.indexOf('?'));

      if (params.indexOf('vhost=') > 0) {
        vhost = params.substr(params.indexOf('vhost=') + 'vhost='.length);
        if (vhost.indexOf('&') > 0) {
          vhost = vhost.substr(0, vhost.indexOf('&'));
        }
      }
    }

    // when vhost equals to server, and server is ip,
    // the vhost is __defaultVhost__
    if (url.hostname == vhost) {
      const re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
      if (re.test(url.hostname)) {
        vhost = '__defaultVhost__';
      }
    }

    // parse the schema
    let schema = 'rtmp';
    if (streamUrl.indexOf('://') > 0) {
      schema = streamUrl.substr(0, streamUrl.indexOf('://'));
    }

    let port = url.port;
    if (!port) {
      switch (schema) {
        case 'http':
          port = '80';
          break;
        case 'https':
          port = '443';
          break;
        case 'rtmp':
          port = '1935';
          break;
        case 'webrtc':
        case 'rtc':
          port = '1985';
          break;
      }
    }

    const ret = {
      url: streamUrl,
      schema,
      server: url.hostname,
      port,
      vhost,
      app,
      stream,
      user_query: {} as any,
      domain: undefined,
    };

    if (url.search.length > 0) {
      for (let pair of url.search.slice(1).split('&')) {
        const [key, value] = pair.split('=');
        ret[key] = value;
        ret.user_query[key] = value;
      }

      if (ret.domain) {
        ret.vhost = ret.domain;
      }
    }

    return ret;
  }

  async fetchStreamAnswer(offer: RTCSessionDescriptionInit, streamurl: string): Promise<RTCSessionDescriptionInit> {
    const { port = '1985', user_query = {}, server } = this.parseUrl(streamurl);

    let api = user_query.play || '/rtc/v1/play/';
    if (!api.endsWith('/')) {
      api += '/';
    }

    let apiUrl = replaceProtocol + server + ':' + port + api;
    for (let key in user_query) {
      if (key !== 'api' && key !== 'play') {
        apiUrl += (apiUrl.includes('?') ? '&' : '?') + key + '=' + user_query[key];
      }
    }

    if (this.abortController) {
      this.abortController.abort('recreate');
    }
    this.abortController = new self.AbortController();

    if (this.fetchTimeout !== Infinity && this.fetchTimeout > 0) {
      this.timerId = setTimeout(() => {
        this.abort('timeout');
      }, this.fetchTimeout);
    }

    try {
      const { url, options } = this.fetchSetup(apiUrl, {
        method: 'post',
        signal: this.abortController.signal,
        body: JSON.stringify({
          api: apiUrl,
          streamurl,
          clientip: null,
          sdp: offer.sdp,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const answer = await fetch(url, options);

      if (!answer.ok) {
        throw new Error(`HTTP error! Status: ${answer.status}`);
      }
      const json = await answer.json();

      if (json.code !== 0 && !json.sdp) {
        throw new Error(`API error! ${JSON.stringify(json)}`);
      }

      return { type: 'answer' as RTCSdpType, sdp: json.sdp };
    } finally {
      this.clearTimeout();
      this.abortController = null;
    }
  }

  fetchStreamSdp(offer: RTCSessionDescriptionInit, url: string): Promise<RTCSessionDescriptionInit> {
    return Promise.resolve(undefined);
  }

  async fetchPeerConnectionConfig(url: string): Promise<RTCConfiguration> {
    return {
      iceServers: [
        {
          urls: 'stun:47.99.56.177:3478',
        },
      ],
    };
  }
}
